import './App.scss';
import config from './config';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import * as ROUTES from './routes/routes';

import NotFound from './pages/notFound/notFound';
import InsurersPage from './pages/insurersPage/insurersPage';
import HomePage from './pages/homePage/homePage';
import ConfirmationPage from './pages/confirmationPage/confirmationPage';

function App() {
    const homePage = <HomePage />;
    return (
        <BrowserRouter basename={config.PUBLIC_URL}>
            <Routes>
                <Route path={ROUTES.ROUTE_ROOT} element={homePage} />
                <Route path={ROUTES.ROUTE_ECLAIMS} element={homePage} />
                <Route path={ROUTES.ROUTE_INSURERS} element={<InsurersPage />} />
                <Route path={ROUTES.ROUTE_CONFIRMATION} element={<ConfirmationPage />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
